import PropTypes from 'prop-types'

import track from '~helpers/track'
import MarketoForm from '~components/MarketoForm'

const DemoForm = ({ id, ...rest }) => (
  <MarketoForm
    id={id}
    onSuccess={() => {
      track('Demo requested', {
        label: `marketo-${id}`,
      })
    }}
    {...rest}
  />
)

DemoForm.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
}

export default DemoForm
